import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './PasswordChangeHome.html?raw';
import PasswordChangeForm from './PasswordChangeForm';
import './PasswordChangeForm';
import GenericDialog from '../GenericDialog/GenericDialog';
import "../GenericDialog/GenericDialog";
import Button from '../Button/Button';
import "../Button/Button";
import { ToasterHelpers, TranslationHelpers } from "../../../more/Helpers";

//import DataItems = require("DataItems");


class PasswordChangeHome extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private messageContainer: HTMLElement;
    private mainMessage: HTMLElement;
    private errorMessage: HTMLElement;
    private successMessage: HTMLElement;

    private mainContainer: HTMLElement;
    private passwordChangeButton: HTMLButtonElement;
    private changeButtonContainer: HTMLElement;
    private changeLinkContainer: HTMLElement;
    private passwordChangeLink: HTMLLinkElement;
    private formContainer: HTMLElement;

    private submitButton: MdsLax<InstanceType<typeof Button>>;
    private submitButtonContainer: HTMLElement;

    passwordChangeform: MdsLax<InstanceType<typeof PasswordChangeForm>> = null;

    private dlg: MdsLax<InstanceType<typeof GenericDialog>> = null;

    private is_validation_enabled: any = null;
    private isSendingAllowed = true;

    isDialog: boolean = true; // ob die Form in einem Dialog aufehen soll oder im formContainer 
    isButton: boolean = true; // wenn false, wird als link dargestellt

    strictMode: boolean = false; // Abbrechen und schließen verhindern, solange nicht erfolgreich geändert

    private _request: any = null;

    private _isFormActive: boolean = false;


    private _onclickPasswordLink(evt: Event): void {
        if (this._isFormActive == true) return;
        this._showPasswordChangeForm();
    }

    private _onclickPasswordButton(evt: Event): void {
        if (this._isFormActive == true) return;
        this._showPasswordChangeForm();
    }


    // Prüft nicht ob die passwörter übereinstimmen - das macht _onClickSendButton
    private _sendPasswordData(): void {
        this.StandbyStart();


        if (this._request != null) {
            this._request.cancel();
        }

        let jsonData = this.passwordChangeform.getSubmitData();

        this._request = this.RequestManager.callfunction(
            //window.appRoot + this.url,
            "Webtool_API_Password__ChangePasswordForUser",
            jsonData,
            lang.hitch(this, this._onSendPasswordDataResult),
            lang.hitch(this, this._onSendPasswordDataError)
        );
    }

    private _onSendPasswordDataResult(response): void {
        this.StandbyStop();

        if (response == "success") {

            if (this.isDialog) {
                //this.dlg._setCancelBtnAttr(false);
                //this.dlg._setCloseBtnAttr(true);
                //this.isSendingAllowed = false;

                this.dlg.close(-1, true);
                ToasterHelpers.showToast("ChangeUserPassword_successText", toasterIcons.confirmCheck);
            } else {
                this.showMessage(TranslationHelpers.translate("ChangeUserPassword_successText"), "success");
                this.passwordChangeform.reset();
            }            
        }

    }

    private _onSendPasswordDataError(err): void {
        this.StandbyStop();

        if (err && err.Message && err.Message == "success") {
            this._onSendPasswordDataResult(err.Message);
            return;
        }

        this._onChangePasswordForm();

        if (err && err.Message) {
            this.showMessage(err.Message, "error");

        } else {
            this.showMessage("Something went wrong, your password was not updated", "error");
        }
    }

    private createPasswordChangeform(customCriteria?: Partial<PasswordCriteria>): void {
        if (this.passwordChangeform != null) {
            this.passwordChangeform = null;
        }

        this.passwordChangeform = new PasswordChangeForm();

        this.passwordChangeform.setup({ customCriteria: customCriteria });

        this.passwordChangeform.placeAt(this.formContainer, "only");

        this.passwordChangeform.on("change", lang.hitch(this, this._onChangePasswordForm));
    }
    /**
     * Das Änderungsformular anzeigen, aber im "strengen" Modus - User muss die Änderung durchführen.
     * @param message
     * @param customCriteria
     */
    showStrict(message?: string, customCriteria?: Partial<PasswordCriteria>): void {
        this.strictMode = true;

        this.show(message, customCriteria);
    }
    /**
     * Änderungsformular anzeigen
     * @param message
     * @param customCriteria
     */
    show(message?: string, customCriteria?: Partial<PasswordCriteria>): void {
        this._showPasswordChangeForm(customCriteria);
        if (message) this.showMessage(message);
    }
    showMessage(message?: string, type?: "error" | "success" | "head") {

        this.hideNode(this.errorMessage);
        this.hideNode(this.successMessage);

        switch (type) {
            case "error":
                this.hideNode(this.errorMessage, !message);
                this.UiModder.domAttr.set(this.errorMessage, "innerHTML", message ? message : "");
                if (message) this.errorMessage.scrollIntoView({ behavior: "smooth" });
                break;
            case "success":
                this.hideNode(this.successMessage, !message);
                this.UiModder.domAttr.set(this.successMessage, "innerHTML", message ? message : "");
                if (message) this.successMessage.scrollIntoView({ behavior: "smooth" });
                break;

            case "head":
            default:
                this.hideNode(this.mainMessage, !message);
                this.UiModder.domAttr.set(this.mainMessage, "innerHTML", message ? message : "");
                if (message) this.mainMessage.scrollIntoView({ behavior: "smooth" });
                break;
        }
    }

    private _showPasswordChangeForm(customCriteria?: Partial<PasswordCriteria>): void {

        this.createPasswordChangeform(customCriteria);

        this.hideNode(this.formContainer, false);

        if (this.isDialog == false) {

            if (this.isButton) {
                this.UiModder.domAttr.set(this.passwordChangeButton, "disabled", true);
            };

        } else {
            if (this.dlg != null) {
                this.dlg.destroy();
                this.dlg = null;
            }

            this.dlg = new GenericDialog();            


            this.dlg.setup({
                content: this.mainContainer,
                header: "ChangeUserPassword_changePwdBtnLabel",
                callback: lang.hitch(this, this._onClick_Submit),
                distinctiveNoCallback: lang.hitch(this, this._onClosedDialog),
                closeOnEnter: false,
                size: "smaller",
                titleIconClass: "fas fa-key",
                additionalButtons: [{
                    internalName: "send",
                    label: "ChangeUserPassword_sendButtonLabel",
                    bCloseOnClick: false,
                    enabled: false,
                    position: "first",
                    styleClass: "primary",
                    iconClass: "fas fa-check",
                    callback: lang.hitch(this, this._onClick_Submit)
                }]
            });


            this.dlg._setCancelBtnAttr(!this.strictMode);

            if (this.strictMode) {
                this.dlg.closeOnEscape = false;
            }

            this.dlg.show();
        }

        this._isFormActive = true;

    }

    private _onClick_Submit(): void {

        if (this.isSendingAllowed) {
            this.submitButton.setReadonly(true);

            if (this.dlg) this.dlg.disableAllButtons();

            this._sendPasswordData();
        }
    }

    private _onClosedDialog(): void {
        this._isFormActive = false;
        if (this.isButton) {
            this.UiModder.domAttr.remove(this.passwordChangeButton, "disabled");
        };
    }


    private _onChangePasswordForm(): void {
        let bValid = this.passwordChangeform.isValid();

        if (this._isFormActive) {
            this.isSendingAllowed = bValid;
            this.submitButton.setReadonly(!bValid);

            //this.UiModder.domStyle.set(this.dlg.btnUserdefined, "cursor", "default");
            if (this.isDialog == true && this.dlg) {
                this.dlg.enableButton("send", bValid);
                this.dlg._setCancelBtnAttr(!this.strictMode);
                this.dlg._setCloseBtnAttr(false);
            }
        }
    }

    addButtonClasses(buttonClasses: string | string[]): void {
        this.UiModder.domClass.add(this.passwordChangeButton, buttonClasses);
    }
    removeButtonClasses(buttonClasses: string | string[]): void {
        this.UiModder.domClass.remove(this.passwordChangeButton, buttonClasses);
    }

    showLinkOrButton(): void {
        this.hideNode(this.changeLinkContainer, this.isButton);
        this.hideNode(this.changeButtonContainer, !this.isButton);
    }

    // GEtters && Setters ---------------------------------------START
    setIsDialog(bool: boolean): void {
        this.isDialog = bool;
        this.hideNode(this.submitButtonContainer, this.isDialog);
    }
   
 

    // Getters && Setters ---------------------------------------END

    // Lifecycle ----------------------------------------------------------

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        //console.log("this._isButton: ", this.isButton);

 

        this.showLinkOrButton();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(PasswordChangeHome);
